export const SUBMISSION_GROUPS_OVERVIEW_SKELETON_HEIGHT = 160;
